import Table from "./Table.jsx";

const TablePartidas = ({ data, error, loading }) => {
  const columns = [
    { header: "Partida", accessor: "body_reference" },
    { header: "Código N.C. (TARIC)", accessor: "nc" },
    { header: "Código E.M.C.S.", accessor: "excise_product_code" },
    { header: "Código Impositivo", accessor: "codigo_impositivo" },
    {
      header: "Cantidad",
      render: (row) => {
        const v = Number(row.quantity);
        return (Math.round(v * 100) / 100).toString();
      },
    },
    { header: "Graduación Alcohólica", accessor: "percentage" },
    { header: "Unidades", accessor: "number_of_packages" },
  ];

  if (loading) return <div>Cargando declaraciones...</div>;
  if (error) return <div className="text-red-600">Error: {error.response.data.detail}</div>;
  if (!data || data.length === 0) return <div>No se han encontrado ninguna declaracion</div>;

  return (
    <div>
      <Table columns={columns} data={data} />
    </div>
  );
};

export default TablePartidas;
